<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <label>Nome</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="atencao_continuada.nome"
                    id="nome"
                  />
                </div>
                <div class="col-md-12">
                  <label>Descrição</label>
                  <ckeditor
                    :editor="editor"
                    v-model="atencao_continuada.descricao"
                    :config="editorConfig"
                  ></ckeditor>
                </div>
                <div class="col-md-12 text-right">
                  <hr />
                  <router-link
                    to="/atencao_continuadas"
                    class="btn btn-back mr-1"
                  >
                    <i class="fa fa-arrow-left"></i> Voltar
                  </router-link>
                  <a class="btn btn-add" @click="save">
                    Salvar
                    <i class="fa fa-save"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

export default {
  name: "imageUpload",
  data() {
    return {
      atencao_continuada: {},
      editor: ClassicEditor,
      editorData: "",
      editorConfig: {
        language: "pt-br",
        toolbar: [
          "heading",
          "|",
          "bold",
          "italic",
          "link",
          "numberedlist",
          "bulletedlist",
          "|",
          "outdent",
          "indent",
          "|",
          "blockquote",
          "inserttable",
          "undo",
          "redo",
        ],
      },
    };
  },
  computed: {},
  methods: {
    save: function () {
      const self = this;
      let api = self.$store.state.api + "atencao_continuadas";

      self.$loading(true);

      if (self.atencao_continuada.id) {
        api += "/" + self.atencao_continuada.id;
        self.atencao_continuada._method = "PUT";
      }

      axios
        .post(api, self.atencao_continuada)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          self.$loading(false);
          this.$router.push("/atencao_continuadas");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
          self.$loading(false);
        });
    },
    getAtencaoContinuada: function (id) {
      const self = this;
      const api = self.$store.state.api + "atencao_continuadas/" + id;

      self.$loading(true);

      axios
        .get(api)
        .then((response) => {
          self.atencao_continuada = response.data.data[0];
          self.$loading(false);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
          self.$loading(false);
        });
    },
  },
  mounted: function () {
    const self = this;
    $("#nome").focus();

    let id = self.$route.params.id;
    if (id) {
      self.getAtencaoContinuada(id);
    }
  },
  components: {
    BaseCrud,
    vSelect,
  },
};
</script>
<style scoped>
.profile_user {
  text-align: center;
}
.photo {
  display: block;
  margin-left: 5px;
  width: 18%;
  border-radius: 10px;
  max-width: 400px;
  max-height: 400px;
  object-fit: cover;
}
.btn-user:hover,
.btn-user[aria-expanded="true"] {
  background: linear-gradient(to right, #000, #666);
  color: #fff !important ;
}
.photo-title {
  color: #000;
  font-size: 18px;
  display: block;
  margin-left: 5px;
  width: 18%;
}
</style>